export default __webpack_public_path__ + "assets/thermometer-mercury-cold.39a9e7ff.svg";